import { Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import {ApiCallsService} from './services/api-calls.service';
import {AngularFireAuth} from '@angular/fire/compat/auth';
import { FooterComponent } from './shared/footer/footer.component';
import { NavComponent } from './shared/nav/nav.component';


@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [NavComponent, RouterOutlet, FooterComponent]
})
export class AppComponent {
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private apiCalls = inject(ApiCallsService);
  private afAuth = inject(AngularFireAuth);
  private destroyRef = inject(DestroyRef);

  title = 'piano-workshop';

  settings;
  published;
  showNav;

  constructor() {
    this.apiCalls.getSettings().pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
        data => {
          this.published = data.published;
          console.log(this.published);
          if (!this.published) {
              console.log('notpublished');
            this.afAuth.authState.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(
                user => {
                  if (user == null && this.router.url !== '/admin') {
                    this.showNav = false;
                    this.router.navigate(['waiting']);
                  } else {
                    this.showNav = true;
                  }
                }
            );
          }
        }
    );
  }
}
